import { Header1 } from '@flatsy/core/MaterialUi/Typo'
import i18n from '@flatsy/utils/translations'
import React from 'react'
import { useStyles } from './Style'

const UploaderHeader: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  return (
    <div className={classes.modalHeader}>
      <Header1 lowerCase className={classes.modalHeaderTitle}>
        {i18n.t('send_us_your_documents')}
      </Header1>
    </div>
  )
}

export default UploaderHeader
